import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER} from '@angular/core';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule} from '@angular/common';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {SideNavBarComponent} from './shared/components/side-nav-bar/side-nav-bar.component';
import {HeaderComponent} from './shared/components/header/header.component';
import {CommentsComponent} from './shared/components/comments/comments.component';

import {NavBarService} from './services/nav-bar/nav-bar.service';
import {LanguageService} from './services/languages/language.service';
import {HttpClientModule} from '@angular/common/http';

import {AboutModule} from './modules/about/about.module';
import {HomeModule} from './modules/home/home.module';

import {ContactsModule} from './modules/contacts/contacts.module';
import {HelpfulModule} from './modules/helpful/helpful.module';
import {EstatesModule} from './modules/estates/estates.module';
import {NewsModule} from './modules/news/news.module';
import {SafePipe} from './shared/pipes/safe/safe-pape';

import {TranslateService} from './shared/pipes/translate/translate.service';
import {ServicesComponent} from './modules/services/services/services.component';
import {TranslateModule} from './shared/pipes/translate/translate.module';
import {DataService} from './shared/services/data.service';
import {RECAPTCHA_KEY} from './shared/constants';

import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings
} from 'ng-recaptcha';


export function setupTranslateFactory(service: TranslateService): Function {
  return () => service.use('bg');
}

@NgModule({
  declarations: [
    AppComponent,
    SideNavBarComponent,
    HeaderComponent,
    CommentsComponent,
    SafePipe,
    ServicesComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule,
    RecaptchaModule,
    HomeModule,
    EstatesModule,
    NewsModule,
    HelpfulModule,
    ContactsModule,
    AboutModule
  ],
  providers: [
    DataService,
    NavBarService,
    LanguageService,
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: RECAPTCHA_KEY
      } as RecaptchaSettings
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
